import { useQuery } from "@tanstack/react-query";
import { appEnvironment } from "../ApplicationContext";
import { useAppSelector } from "../redux/hooks";
import { CurrentUser } from "../types/CurrentUser";
import { ExtendedErrorResponse } from "../types/ErrorResponse";
import { QueryHookOutput } from "./interfaces/DataHookOutput";

export default function useCurrentUser(): QueryHookOutput<CurrentUser> {
    const token = useAppSelector((state) => state.auth.token);

    return useQuery<CurrentUser, ExtendedErrorResponse>({
        enabled: !!token,
        queryKey: ["current-user-info"],
        queryFn: async () => {
            const response = await fetch(`${appEnvironment.REACT_APP_PROFILE_BASEURL}`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });

            if (response.ok) {
                return (await response.json()) as CurrentUser;
            }

            let potentialJsonError: unknown = {};
            try {
                potentialJsonError = await response.json();
            } catch (_) {
                // ignore
            }

            throw {
                status: response.status,
                statusText: response.statusText,
                error: potentialJsonError,
            } satisfies ExtendedErrorResponse;
        },
    });
}
